import { useEffect, useState } from 'react';

export const STORAGE_CAMERA_PERMISSION_KEY = 'CAMERA_PERMISSION_REQUESTED';

export const useCameraPermission = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    const checkPermission = async () => {
      const werePermissionsRequested = localStorage.getItem(
        STORAGE_CAMERA_PERMISSION_KEY
      );

      if (!!werePermissionsRequested) {
        return;
      }

      if (navigator.permissions) {
        try {
          const result = await navigator.permissions.query({
            name: 'camera' as PermissionName,
          });
          if (result.state !== 'denied' && result.state !== 'granted') {
            setShowModal(true);
          }
        } catch (e) {
          // If query fails, show modal as fallback
          setShowModal(true);
        }
      } else {
        // If Permissions API not available, show modal as fallback
        setShowModal(true);
      }
    };

    checkPermission();
  }, []);

  return { showModal, setShowModal };
};
